$(document).ready(function () {
  let submitButton = $('#subscribe_submit_button');
  let warningSubmitButton = $('#warning_subscribe_modal_submit_btn');

  if (submitButton.length == 0) {
    return;
  }

  submitButton.click(triggerSubscriptionConfirmModal);
  $(document).on("keydown", "#newSubscriptionForm", function (event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      triggerSubscriptionConfirmModal();
      return;
    }
  });

  $(".form-check-input").on("change", function () {
    if ($(".form-check-input:checked").length == $(".form-check-input").length) {
      warningSubmitButton.prop("disabled", false);
    } else {
      warningSubmitButton.prop("disabled", true);
    }
  });

  function triggerSubscriptionConfirmModal() {
    let subscriptionAmountField = $("#subscription_amount_field");
    let warningModal = $('#NonInformedProfileWarningModal');
    const subscribeConfirmationText = $('.subscribe-confirmation-text');
    const shareValue = $('.subscribe-confirmation-text').data("shareValue");

    amount = subscriptionAmountField.val();
    const numberOfSharesForAmount = amount / shareValue;

    subscribeConfirmationText.text(
      `${numberOfSharesForAmount} part${numberOfSharesForAmount > 1 ? 's' : ''} (${amount} €) pour le projet`
    );

    if (!subscriptionAmountField[0].checkValidity()) {
      document.getElementById("fields_errors").innerHTML = subscriptionAmountField[0].validationMessage;
      return false;
    } else if (amount === "") {
      document.getElementById("fields_errors").innerHTML = "Un montant de souscription doit être renseigné.";
      return false;
    } else {
      document.getElementById("fields_errors").innerHTML = "";
    }

    if (subscriptionAmountField.data("userMayHaveWarning") === true) {
      $.ajax({
        type: "GET",
        url: subscriptionAmountField.data("url"),
        data: '&[amount]=' + amount,
        dataType: "json",
        success: function (response) {
          let warning_modal_required = response["warning_modal_required"]

          if (warning_modal_required) {
            warningModal.modal('show');
          } else {
            $('#subscribeModal').modal('show');
          }
        },
        error: function (response) {
          document.getElementById("fields_errors").innerHTML = "Une erreur s'est produite, veuillez réessayer.";
        }
      });
    } else {
      $('#subscribeModal').modal('show');
    }
  };
});
